import { ContainerSect } from "./Container.js";

export const Container = ({ children }) => {
  return <ContainerSect>{children}</ContainerSect>;
};
